import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';
import {TagService} from '../../../services/tag.service';

@Component({
  selector: 'app-new-tag',
  templateUrl: './new-tag.component.html',
  styleUrls: ['./new-tag.component.scss']
})
export class NewTagComponent implements OnInit {

  tag = {
    name: ''
  };

  constructor(private graphqlService: TagService,
              private utilsService: UtilsService,
              private router: Router) {
  }

  ngOnInit() {

  }

  createTag() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.tag.name);
    if (requiredSuccess) {
      this.graphqlService.create(this.tag).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Tag Created !!', '');
          this.router.navigate(['/tags']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create tag.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/tags/new-tag/new-tag.component.ts